'use client'
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/marquee/Banner.tsx
import { Divider, Typography } from "@wbk/ui";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var MarqueeBanner = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!cards || !cards.length) return null;
  const cardsExtended = Array.from({ length: 40 }).flatMap(() => cards);
  return /* @__PURE__ */ jsx(DecoratedSection_default, { section, "data-testid": `section_announcement_banner_${section.id}`, children: /* @__PURE__ */ jsx("div", { className: "overflow-x-hidden", children: /* @__PURE__ */ jsx("div", { className: "rtl:animate-marquee-left ltr:animate-marquee-right py-M gap-L relative flex flex-row-reverse whitespace-nowrap will-change-transform", children: cardsExtended.map((card) => /* @__PURE__ */ jsxs("div", { className: "gap-XS flex shrink-0 items-center justify-center", children: [
    /* @__PURE__ */ jsx(ContentfulMedia_default, { media: card.icon, className: card.title ? "h-4 w-4" : void 0 }),
    card.title && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Divider, { className: "border-paper-level-4 h-4 border" }),
      /* @__PURE__ */ jsx(Typography, { variant: "label-M", children: card.title }, card.id),
      /* @__PURE__ */ jsx(Divider, { className: "border-paper-level-4 h-4 border" })
    ] })
  ] }, card.id)) }) }) });
};
var Banner_default = MarqueeBanner;

export {
  Banner_default
};
//# sourceMappingURL=chunk-OMR6AITC.mjs.map